module.exports = __webpack_public_path__ + "img/icon-check.f44f5635.svg";